import React from "react";
import Helmet from "react-helmet";
import Link from "gatsby-link";
import kebabCase from "lodash/kebabCase";

const TagsPage = ({
    data: { allMarkdownRemark: { group }, site: { siteMetadata: { title } } },
}) => (
        <div>
            <Helmet title={title} />
            <div>
                <h1>Tags</h1>
                <ul>
                    {group.map(tag => (
                        <li key={tag.fieldValue}>
                            <Link to={`/tags/${kebabCase(tag.fieldValue)}/`}>
                                {tag.fieldValue} ({tag.totalCount})
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );

export default TagsPage;

export const pageQuery = graphql`
  query TagsQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 2000
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;




// WEBPACK FOOTER //
// ./src/pages/tags/index.js